module.exports = __webpack_public_path__ + "media/images/payments/paymill-dark-333793d1d77ea0288457087e02f00968.svg";